"use client";

/**
 * P9-01 · Wires page-view capture and exposes `useTrack()` to storefront client
 * components. Mounted in the storefront layout (not admin). PAGE_VIEW fires on
 * every route change; other events (product view, add-to-cart, checkout start)
 * are emitted from their own surfaces via `useTrack()`.
 */
import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { track } from "./client";
import type { ClientEvent, ClientEventType } from "./events";

export function AnalyticsProvider() {
  const pathname = usePathname();
  useEffect(() => {
    track("PAGE_VIEW", { path: pathname });
  }, [pathname]);
  return null;
}

/** The stable emitter for storefront components. */
export function useTrack(): (
  type: ClientEventType,
  payload?: Omit<ClientEvent, "type">,
) => void {
  return track;
}
